import styled from '@emotion/styled';
import { Colors, helperBgBlured, helperSafeArea, media } from '@utex/ui-kit';

interface ContainerProps {
  duration: number;
}

export const Container = styled('div')<ContainerProps>`
  ${helperBgBlured};
  position: fixed;
  z-index: 200;
  left: 100%;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  width: 32rem;
  transition-property: transform, box-shadow;
  transition-duration: ${(props) => `${props.duration}ms`};

  &:before {
    content: '';
    position: absolute;
    right: 100%;
    top: 0;
    bottom: 0;
    width: 100vw;
    transition-property: background-color;
    transition-duration: inherit;

    @media ${media.tablesktop} {
      display: none;
    }
  }

  &.sidemenu-enter-active,
  &.sidemenu-enter-done {
    transform: translateX(-100%);
    box-shadow: 0 0.4rem 1.4rem ${Colors.ut.popupShadow}, 0 1.1rem 6rem ${Colors.ut.popupShadow};

    &:before {
      background-color: ${Colors.ut.modalOverlay};
    }
  }
`;

export const Wrapper = styled('div')`
  ${helperSafeArea};
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  flex-grow: 1;
  display: inherit;
  flex-direction: inherit;
  padding-top: 1.7rem;
`;

export const ButtonClose = styled('div')`
  position: absolute;
  z-index: 2;
  right: 0;
  top: 0;
  padding: 1rem;
`;
